import './PairingEventLayoverSegment.scss';

const PairingLayoverSegment = ({segment, uniqueId, width}) => {  
    return (
        <div className="c-pairing-layover-segment" style={{width:`${segment.segmentLength/width*10000}%`}}>  
            {segment.hideLayoverInformation ? 
                <div id={`layoverSegment__${uniqueId}_${segment.layoverCount}`} className="layover-segment layover-segment--no-text"/>
            :   
                <>
                    <div id={`layoverLocCntr__${uniqueId}_${segment.layoverCount}`} className="c-layover-loc">
                        <p id={`layoverAirportCodeCntr__${uniqueId}_${segment.layoverCount}`} className="c-layover-airport-code">
                            <span id={`layoverHotelIcon__${uniqueId}_${segment.layoverCount}`} className="icon-Hotel"></span>
                            <span id={`layoverAirportCode__${uniqueId}_${segment.layoverCount}`} className="layover-airport-code">{segment.layoverLocation}</span>
                        </p>
                    </div> 
                    <div id={`layoverSegment__${uniqueId}_${segment.layoverCount}`} className="layover-segment" />
                    <div id={`layoverDurCntr__${uniqueId}_${segment.layoverCount}`} className="c-layover-duration">
                        <span id={`layoverStartTime__${uniqueId}_${segment.layoverCount}`} className="layover-duration__start-time">{segment.layoverStartTime}</span>
                        <div id={`layoverSubCntr__${uniqueId}_${segment.layoverCount}`} className="c-layover-duration__sub">
                            <span id={`layoverDuration__${uniqueId}_${segment.layoverCount}`} className={`layover-duration__${segment.layoverType}`}>{segment.layoverDuration}</span>
                            <span id={`layoverEndTime__${uniqueId}_${segment.layoverCount}`} className="layover-duration__end-time">{segment.layoverEndTime}</span>
                        </div>
                    </div>
                    <div id={`hotel_${uniqueId}_${segment.layoverCount}`} className="layover__hotel">
                        <span id={`hotel_span_${uniqueId}_${segment.layoverCount}`} className="layover__hotel__span">{segment.layoverPlace}</span>
                    </div>
                </>
            }
        </div>
    )
}

export default PairingLayoverSegment;